var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c(
        "base-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isRefreshing,
              expression: "isRefreshing",
            },
          ],
          ref: "baseTable",
          attrs: {
            "base-url": _vm.urlWithFilters,
            "current-page": _vm.currentPage,
            "element-loading-spinner": "el-icon-loading",
          },
          on: {
            "load-success": _vm.onLoadSuccess,
            "load-error": _vm.onLoadError,
            refresh: _vm.onRefresh,
          },
        },
        [
          _c(
            "el-table",
            { staticClass: "w-100", attrs: { data: _vm.items, stripe: "" } },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_c("expand-column", { attrs: { row: row } })]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Contact",
                  prop: "contact",
                  "min-width": "250",
                  formatter: _vm.formatFullName,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Contact's Message",
                  prop: "contact.message_created_at",
                  "min-width": "140",
                  formatter: _vm.formatDate,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Contact's Message Excerpt",
                  prop: "contact.message_excerpt",
                  "min-width": "350",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({
                      row: {
                        contact: { message_excerpt },
                      },
                    }) {
                      return [
                        _c("div", { staticClass: "message-content" }, [
                          _vm._v(_vm._s(message_excerpt)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Outgoing Number",
                  "min-width": "250",
                  prop: "outgoing_number",
                  formatter: _vm.formatOutgoingNumber,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Staff's Response",
                  prop: "staff.message_created_at",
                  "min-width": "140",
                  formatter: _vm.formatDate,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Response Lag",
                  prop: "answer_lag",
                  "min-width": "100",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "text-right",
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }